import { render, staticRenderFns } from "./carrito.vue?vue&type=template&id=1e2b42d1&scoped=true&"
import script from "./carrito.vue?vue&type=script&lang=js&"
export * from "./carrito.vue?vue&type=script&lang=js&"
import style0 from "./carrito.vue?vue&type=style&index=0&id=1e2b42d1&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2b42d1",
  null
  
)

export default component.exports